function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4D4D4D",
  fillRule: "nonzero",
  d: "M21.667 16.653c0-2.868-1.157-4.96-3.18-6.665-.588-.495-2.171-1.597-2.297-1.71-1.84-1.646-2.545-3.174-1.861-6.014.263-1.096-.867-2.004-1.88-1.51-4.377 2.132-6.152 6.621-5.81 10.612-.513-.738-.865-1.702-.98-2.834-.127-1.26-1.774-1.649-2.452-.58-2.144 3.38-2.874 5.412-2.874 8.7a10.65 10.65 0 0 0 10.682 10.681c5.87 0 10.652-4.705 10.652-10.68zM3 16.653c0-2.716.563-3.68.955-4.606C4.974 14.02 6.64 15.31 8.326 15.31c.85 0 1.483-.785 1.303-1.615-1.157-5.358.896-8.065 1.79-8.936.146 2.244 1.226 3.927 2.993 5.507.28.25 1.906 1.381 2.356 1.76C18.233 13.263 19 14.649 19 16.654a7.96 7.96 0 0 1-7.985 8.014A7.984 7.984 0 0 1 3 16.653z"
});

var SvgHotBenefit = function SvgHotBenefit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHotBenefit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hot-benefit.2481b323.svg";
export { ForwardRef as ReactComponent };